import { createStatusDate } from "@/utils";
import { Grid } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { BookingStatus } from "@shared/server";
import { DateBox } from "./components";

interface DatesProps {
    endDate: string;
    date: Date;
    statusData: BookingStatus[];
}

export const Dates = ({ date, statusData, endDate }: DatesProps) => {
    const { datesArray, backLength } = createStatusDate(date);
    const differentLength = datesArray.length - statusData.length - backLength;

    return (
        <CustomGrid>
            {datesArray.map((it, index) => {
                const childNumber = (index + 1) % 7 === 0 ? index + 1 : null;
                const newIdx = it.date !== "" && index - differentLength;

                // if (it.date === "") return <DateBox key={index} dateNum={it.date} childNumber={childNumber} />;

                return (
                    <DateBox
                        key={index}
                        dateNum={it.date}
                        result={statusData[newIdx as number]}
                        endDate={endDate}
                        childNumber={childNumber}
                    />
                );
            })}
        </CustomGrid>
    );
};

const CustomGrid = styled(Grid)`
    width: 100%;
    grid-template-columns: repeat(7, 1fr);
`;
